module.exports = __webpack_public_path__ + "img/jundushan.50168302.png";